// extracted by mini-css-extract-plugin
export default {"card":"KrLu69WnthGpp1j17rpY","pulse":"M0d63D57WgUTpDo8urVG"};